module.exports = __webpack_public_path__ + "static/img/theme_03.84bbe928.png";